// src/hooks/useActivityTracking.ts
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Roles } from '../constants/Roles';
import {
  ACTIVITY_ENABLED, ActivityGame, endGame, startGame,
} from '../services/activity';
import { getActiveList, getUserData } from '../views/auth/slice/selectors';

// Monitoring aktywności w grze: pomiar od wejścia do wyjścia z gry, a każdą próbę gra zapisuje przez `recordAnswer`
// z src/services/activity.ts. Tylko konto ucznia — nauczyciel na podglądzie gry nic nie wysyła
const useActivityTracking = (game: ActivityGame): void => {
  const user = useSelector(getUserData);
  const listId: number | undefined = useSelector(getActiveList)?.id;
  const studentId = ACTIVITY_ENABLED && user?.role === Roles.STUDENT ? user.id : undefined;

  useEffect(() => {
    if (!studentId || !listId) return undefined;

    const session = startGame(game, listId, studentId);

    return () => endGame(session);
  }, [game, listId, studentId]);
};

export default useActivityTracking;
